import { Skeleton as SkeletonComponent } from '~/shared/ui/SkeletonList'

export function Skeleton() {
  return (
    <div style={{ width: '100%' }}>
      <SkeletonComponent
        style={{
          borderRadius: '16px',
          aspectRatio: '1/0.7',
          marginBottom: '12px',
          height: 'auto',
        }}
      />
      <SkeletonComponent style={{ borderRadius: '16px', height: '107px' }} />
    </div>
  )
}
